import { render } from "./pagetemplate.vue?vue&type=template&id=bdfe229a&scoped=true"
import script from "./pagetemplate.vue?vue&type=script&lang=js"
export * from "./pagetemplate.vue?vue&type=script&lang=js"

import "./pagetemplate.vue?vue&type=style&index=0&id=bdfe229a&lang=css"
import "./pagetemplate.vue?vue&type=style&index=1&id=bdfe229a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdfe229a"]])

export default __exports__